import {Serializer} from "../interfaces/serializer";
import {DataSetConditionalDimension, DataSetDimension, DataSourceDimension, Dimension, GeneralDimension} from '../interfaces/dimensions';
import {BehaviorSubject} from "rxjs";

export type DimensionComponentObjects = Array<DimensionComponentObject>;

export class DimensionComponentObject {
  public payload: Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension | DataSourceDimension | Dimension>;

  public name$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public slug$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    payload: Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension | DataSourceDimension | Dimension>
  ) {
    this.update(payload);
  }

  public update(payload: Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension | DataSourceDimension | Dimension>): void {
    this.payload = payload;

    this.name$.next(payload.attributes.name);
    this.slug$.next(payload.attributes.slug);
  }

}
